module.exports = __webpack_public_path__ + "static/img/video_avatar.9fdac280.png";